import { useStakingProvider } from '@trustpad/launchpad/dist/staking/hooks/useStaking';

import * as React from 'react';
import CountUp from 'react-countup';
import Skeleton from 'react-loading-skeleton';

import { fNum, toEthN } from '~utils';

export function StakingStats({
  priceLabel,
  forceAprZero,
}: {
  priceLabel: string;
  forceAprZero: boolean;
}) {
  const { totalStats, userStats, totalValue, pool } = useStakingProvider();
  const { lpDeposited, pendingReward } = userStats;

  return (
    <div className="flex justify-around items-center flex-wrap md:flex-nowrap">
      <Item label="Staked">
        {fNum(lpDeposited)} {priceLabel}
      </Item>

      <Item label="Earned">
        <span>
          <CountUp end={toEthN(pendingReward)} decimals={2} preserveValue />{' '}
          {pool.rewardToken.symbol}
        </span>
      </Item>

      <Item label="APR">
        <span className="brand-text text-3xl min-w-12">
          {forceAprZero ? (
            0
          ) : totalStats.apr > 0 ? (
            <>
              <CountUp end={totalStats.apr} preserveValue />%
            </>
          ) : (
            <Skeleton className="w-12" />
          )}
        </span>
      </Item>

      <Item label={`${priceLabel} Price`}>
        ${fNum(totalStats.stakingTokenPrice)}
      </Item>

      <Item label="Total Value Locked">${fNum(totalValue)}</Item>
    </div>
  );
}

function Item({ label, children }) {
  return (
    <div className="flex flex-col items-center md:w-1/5 py-3">
      <div className="flex items-center text-lg">{children}</div>
      <div className="text-sm opacity-50">{label}</div>
    </div>
  );
}
